import React, { useEffect } from "react";
import { ITelemetryClient } from "sonobello.utilities.react.telemetry";

import { TelemetrySessionTags } from "../../../../Telemetry/Types/ITelemetryClient";
import { UserEventType } from "../../../Types/IUserEvent";
import IHeatmappingClient from "../../Types/IHeatmappingClient";
import IUserEventConsumerProps from "../../Types/IUserEventConsumerProps";
import IGoogleTagsManagerEventFactory from "./GoogleTagsManagerEventFactory";

export interface IGoogleTagsUserEventConsumerConfig {
  eventFactory: IGoogleTagsManagerEventFactory;
  heatmappingClient: IHeatmappingClient;
  rules: Partial<Record<UserEventType, (event: unknown) => boolean>>;
  telemetryClient: ITelemetryClient<TelemetrySessionTags>;
}

const GoogleTagsUserEventConsumer: React.FC<IGoogleTagsUserEventConsumerConfig & IUserEventConsumerProps> = ({
  eventFactory,
  heatmappingClient,
  rules,
  telemetryClient,
  userEvent
}) => {
  useEffect(() => {
    if (!userEvent) return;

    const eventRule = rules[userEvent.type];

    if (eventRule && !eventRule(userEvent)) return;

    const event = eventFactory.buildEvent(userEvent);

    if (!event) {
      telemetryClient.traceException(
        new Error(`No Google Tags event name mapped for user event type: ${UserEventType[userEvent.type]}`)
      );
      return;
    }
    try {
      heatmappingClient.pushEvent(event);
    } catch (error) {
      telemetryClient.traceException(error as Error);
    }
  }, [userEvent]);

  return null;
};

export default GoogleTagsUserEventConsumer;
